(function () {
  var STORAGE_KEY = '__crpt__attribution';
  var URL_PARAMS = [
    'fbclid', 'gclid', 'msclkid',
    'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'
  ];

  function getCookie(name) {
    var pairs = document.cookie.split(';');
    var prefix = name + '=';
    for (var i = 0; i < pairs.length; i++) {
      var pair = pairs[i];
      while (pair.charAt(0) === ' ') pair = pair.substring(1);
      if (pair.indexOf(prefix) === 0) {
        try {
          return decodeURIComponent(pair.substring(prefix.length));
        } catch (e) {
          return pair.substring(prefix.length);
        }
      }
    }
    return '';
  }

  function getUserAgent() {
    if (navigator.userAgent) {
      return navigator.userAgent;
    }
    var uad = navigator.userAgentData;
    if (uad && uad.brands && uad.brands.length) {
      var brands = uad.brands.map(function (b) {
        return b.brand + '/' + b.version;
      }).join(' ');
      return [uad.platform || '', brands, uad.mobile ? 'Mobile' : 'Desktop']
        .filter(Boolean).join(' ');
    }
    return '';
  }

  function readUrlParams() {
    var out = {};
    var qs;
    try {
      qs = new URLSearchParams(window.location.search);
    } catch (e) {
      return out;
    }
    URL_PARAMS.forEach(function (key) {
      var value = qs.get(key);
      if (value) out[key] = value;
    });
    return out;
  }

  function persistFromUrl() {
    var fresh = readUrlParams();
    if (!Object.keys(fresh).length) return;
    try {
      var existing = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}');
      Object.keys(fresh).forEach(function (k) { existing[k] = fresh[k]; });
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(existing));
    } catch (e) {}
  }

  function loadPersisted() {
    try {
      return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}');
    } catch (e) {
      return {};
    }
  }

  function capture() {
    var persisted = loadPersisted();
    var current = readUrlParams();
    var merged = {};
    Object.keys(persisted).forEach(function (k) { merged[k] = persisted[k]; });
    Object.keys(current).forEach(function (k) { merged[k] = current[k]; });
    return {
      fbclid: merged.fbclid || '',
      gclid: merged.gclid || '',
      msclkid: merged.msclkid || '',
      utm_source: merged.utm_source || '',
      utm_medium: merged.utm_medium || '',
      utm_campaign: merged.utm_campaign || '',
      utm_content: merged.utm_content || '',
      utm_term: merged.utm_term || '',
      fbc: getCookie('_fbc'),
      fbp: getCookie('_fbp'),
      page_path: window.location.pathname || '',
      page_url: window.location.href || '',
      page_title: document.title || '',
      page_referrer: document.referrer || '',
      user_agent: getUserAgent()
    };
  }

  window.CRAttribution = { capture: capture };
  persistFromUrl();
})();
